export const DRONE_PROVIDERS = {
  Evercam: "Evercam",
  Dronedeploy: "DroneDeploy",
}
